import { render, staticRenderFns } from "./PaymentComponent.vue?vue&type=template&id=0bc00860&scoped=true&"
import script from "./PaymentComponent.vue?vue&type=script&lang=js&"
export * from "./PaymentComponent.vue?vue&type=script&lang=js&"
import style0 from "./PaymentComponent.vue?vue&type=style&index=0&id=0bc00860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc00860",
  null
  
)

export default component.exports